export const getColumns = (selectedFields, allFields) =>
  selectedFields.reduce((acc, obj, currentIndex) => {
    let result = acc
    if (typeof acc === 'string') result = []
    if (currentIndex === 1) {
      const foundFirst = allFields.find(item => item.field === acc)
      if (foundFirst) result = [foundFirst]
    }
    const found = allFields.find(item => item.field === obj)
    return [...result, ...[found]]
  })
